import { REPORT_ACTION_OPTIONS } from '../report/actions'
import type { ReportUserStatus } from './types'
import type { ActionOptions } from 'state/report/types'
import type { ReportField } from './inlineUpdates'

export const API_REPORTS_INDEX = 'API_REPORTS_INDEX'
export const API_REPORTS_INDEX_SUCCESS = 'API_REPORTS_INDEX_SUCCESS'
export const API_REPORTS_INDEX_FAILURE = 'API_REPORTS_INDEX_FAILURE'
export const API_REPORTS_SET_ALL_FILTERS = 'API_REPORTS_SET_ALL_FILTERS'

export const FETCH_REPORT_DETAIL = 'FETCH_REPORT_DETAIL'
export const FETCH_REPORT_DETAIL_SUCCESS = 'FETCH_REPORT_DETAIL_SUCCESS'
export const FETCH_REPORT_DETAIL_FAILURE = 'FETCH_REPORT_DETAIL_FAILURE'

export const UPDATE_REPORT_USER_STATUS = 'UPDATE_REPORT_USER_STATUS'
export const UPDATE_REPORT_USER_STATUS_SUCCESS = 'UPDATE_REPORT_USER_STATUS_SUCCESS'
export const UPDATE_REPORT_USER_STATUS_FAILURE = 'UPDATE_REPORT_USER_STATUS_FAILURE'

export const API_REPORTS_FACETS_INDEX = 'API_REPORTS_FACETS_INDEX'
export const API_REPORTS_FACETS_INDEX_SUCCESS = 'API_REPORTS_FACETS_INDEX_SUCCESS'
export const API_REPORTS_FACETS_INDEX_FAILURE = 'API_REPORTS_FACETS_INDEX_FAILURE'

export const API_REPORTS_ALL_FACETS_INDEX = 'API_REPORTS_ALL_FACETS_INDEX'
export const API_REPORTS_ALL_FACETS_INDEX_SUCCESS = 'API_REPORTS_ALL_FACETS_INDEX_SUCCESS'
export const API_REPORTS_ALL_FACETS_INDEX_FAILURE = 'API_REPORTS_ALL_FACETS_INDEX_FAILURE'

export const SET_SINGLE_REPORT_REVIEW_STATUS = 'SET_SINGLE_REPORT_REVIEW_STATUS'
export const SET_SINGLE_REPORT_FOLLOW_UP_LABEL = 'SET_SINGLE_REPORT_FOLLOW_UP_LABEL'
export const SET_SINGLE_REPORT_USER_STATUS = 'SET_SINGLE_REPORT_USER_STATUS'

export const INLINE_UPDATE_BEGIN = 'INLINE_UPDATE_BEGIN'
export const INLINE_UPDATE_SUCCESS = 'INLINE_UPDATE_SUCCESS'
export const INLINE_UPDATE_FAILURE = 'INLINE_UPDATE_FAILURE'

export const CACHE_MORE_REPORTS = 'CACHE_MORE_REPORTS'
export const CACHE_MORE_REPORTS_SUCCESS = 'CACHE_MORE_REPORTS_SUCCESS'
export const CACHE_MORE_REPORTS_FAILURE = 'CACHE_MORE_REPORTS_FAILURE'

export const fetchReports = () => ({ type: API_REPORTS_INDEX })

export const fetchReportDetail = (reportId: number) => ({
  type: FETCH_REPORT_DETAIL,
  reportId,
})

export const updateReportUserStatus = (userStatus: ReportUserStatus) => ({
  type: UPDATE_REPORT_USER_STATUS,
  userStatus,
})

export const setAllFilters = (filters: any, options: ActionOptions = REPORT_ACTION_OPTIONS) => {
  return ({
    type: API_REPORTS_SET_ALL_FILTERS,
    ...filters,
    options
  })
}

export const fetchReportFacets = () => ({ type: API_REPORTS_FACETS_INDEX })

export const fetchAllReportFacets = (options?: any) => ({ type: API_REPORTS_ALL_FACETS_INDEX, options })

export const setSingleReportReviewStatus = (reportId: string, reviewStatus: string) => ({
  type: SET_SINGLE_REPORT_REVIEW_STATUS,
  payload: { reportId, reviewStatus }
})

export const setSingleReportFollowUpLabel = (
  reportId: string,
  followUpLabel: string,
  customFollowUpLabel: any,
  labelNote: string,
) => ({
  type: SET_SINGLE_REPORT_FOLLOW_UP_LABEL,
  payload: {
    reportId,
    followUpLabel,
    customFollowUpLabel,
    labelNote,
  }
})

export const setSingleReportUserStatus = (reportId: string, userStatus: any) => ({
  type: SET_SINGLE_REPORT_USER_STATUS,
  payload: { reportId, userStatus },
})

export const beginInlineUpdate = (reportId: string, field: ReportField) => ({
  type: INLINE_UPDATE_BEGIN,
  payload: { reportId, field },
})

export const successInlineUpdate = (reportId: string, field: ReportField) => ({
  type: INLINE_UPDATE_SUCCESS,
  payload: { reportId, field },
})

export const failureInlineUpdate = (reportId: string, field: ReportField, error: string) => ({
  type: INLINE_UPDATE_FAILURE,
  payload: { reportId, field, error },
})

export const cacheMoreReports = (extendLimitBy = 0, options: ActionOptions = REPORT_ACTION_OPTIONS) => ({
  type: CACHE_MORE_REPORTS,
  payload: {
    extendLimitBy,
    options
  }
})
